import * as React from 'react';
import UploadFile from './UploadFile';
import * as api from '../../../api/uploadFile';
import { getFileExtension, getFileIconUrlByFileExtension } from '../../../utils/uploadFileUtility';
import { FileTypes } from '../../../utils/constValues';

export interface Props {
    files: Array<UploadFile>;
    fileSizeMB: number;
    totalfileSizesMB: number;
    fileTypes: Array<FileTypes>;
    hiddenListFile?: boolean;
    customClassName?: string;
    decorateButton?: boolean; // unused
    addFile: (file: UploadFile) => void;
    removeFile: (file: UploadFile) => void;
    disabled?: boolean;
    icon?: JSX.Element;
    textButton?: string;
    sendToVendor?: boolean;
}

export interface State {
    isUploading: boolean;

    errorUpload: string;
}

export default class FileUpload extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {
            isUploading: false,
            errorUpload: ''
        };
    }

    checkMimeType = (e: React.ChangeEvent<HTMLInputElement>) => {
        /* getting file object */
        if (e.target.files !== null) {
            let files: FileList = e.target.files;
            let err = '';

            for (var x = 0; x < files.length; x++) {
                if (this.props.fileTypes.every(type => files[x].type !== type.toString())) {
                    let allowFileTypes = this.props.fileTypes.map(item => '.' + this.getKeyByValue(item));
                    if (allowFileTypes.includes('.JPG')) {
                        allowFileTypes.push('.JPEG');
                    }
                    let allowTypesStr = allowFileTypes.join(', ');
                    err += ' File type is not a supported format.\nFile format should be: ' + allowTypesStr;
                }
            }

            if (err !== '') {
                /* discard selected file */
                e.target.value = '';
                this.setState({ errorUpload: err });
                return false;
            }
            return true;
        }
        return false;
    }

    getKeyByValue = (value: string): string => {
        const indexOfS = Object.values(FileTypes).indexOf(value as unknown as FileTypes);
        const key = Object.keys(FileTypes)[indexOfS];
        return key;
    }

    checkFileSize = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files !== null) {
            let files = e.target.files;
            let size = this.props.fileSizeMB * 1000000;
            let totalFileSizes = this.props.totalfileSizesMB * 1000000;
            let err = '';

            for (var x = 0; x < files.length; x++) {
                if (files[x].size > size) {
                    err += ' The maximum a file size is ' + this.props.fileSizeMB.toString() + ' MB' + ', please pick a smaller file\n';
                } else {
                    //new files + previous files to get totalSize
                    let totalSize = files[x].size;
                    this.props.files.forEach(file => {
                        totalSize += file.fileSize;
                    });

                    if (totalSize > totalFileSizes) {
                        err += ' The maximum total files size is ' + this.props.totalfileSizesMB.toString() + ' MB' + ', please pick a smaller file\n';
                    }
                }
            }

            if (err !== '') {
                e.target.value = '';
                this.setState({ errorUpload: err });
                return false;
            }

            return true;
        }
        return false;
    }

    handleChangeUploadFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();

        this.setState({ errorUpload: '' });
        let files = e.target.files;

        if (files !== null && files.length > 0) {
            if (this.checkMimeType(e) && this.checkFileSize(e)) {
                var data = new FormData();

                for (var x = 0; x < files.length; x++) {
                    data.append('file ' + x, files[x]);
                }

                this.setState({ isUploading: true });
                api.uploadFile(data)
                    .then((response: UploadFileResponse) => {
                        this.setState({
                            isUploading: false
                        });
                        if (response.success) {
                            this.props.addFile({
                                id: '',
                                name: response.name,
                                fileName: response.fileName,
                                url: response.url,
                                sourceType: '',
                                fileSize: response.fileSize,
                                assignTo: []
                            });
                        }
                        e.target.value = '';
                    });
            }
        }
    }

    render(): JSX.Element {
        const { disabled, icon, textButton, customClassName } = this.props;
        const { isUploading } = this.state;
        let displayIcon = icon ? icon : <i className="fa fa-folder-open-o" />;
        let displayTextButton = textButton ? textButton : 'Choose file';
        let className = customClassName ? customClassName : 'btn btn-sm btn-light btn-file';

        return (
            <div style={{ display: 'inline-block' }}>
                <button type="button" className={className} disabled={disabled}>
                    {displayIcon} {displayTextButton}
                    {!disabled && <input type="file" accept={this.props.fileTypes.toString()} onChange={(e) => this.handleChangeUploadFile(e)} />}
                </button>
                {
                    isUploading && <span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />
                }

                {this.state.errorUpload ? <span className="attach-file-error" >{this.state.errorUpload}</span> : ''}
                <br />
                {
                    this.props.hiddenListFile === true ? '' :
                        <ul>
                            {
                                this.props.files.map(item => (
                                    <li key={item.url}>
                                        <img className="icon-file-style" src={getFileIconUrlByFileExtension(getFileExtension(item.name))} />
                                        <a href={item.url} target="_blank">{item.name}</a>&nbsp;&nbsp;
                                        <a href="#" onClick={(e) => { e.preventDefault(); return this.props.removeFile(item); }}><i className="fa fa-times" /></a>
                                    </li>
                                ))
                            }
                        </ul>
                }
            </div>
        );
    }
}

export class UploadFileResponse {
    public success: boolean;
    public message: string;
    public name: string;
    public fileName: string;
    public url: string;
    public fileSize: number;
}


// WEBPACK FOOTER //
// ./src/components/shared/FileUpload/FileUpload.tsx